module.exports = __webpack_public_path__ + "img/olo.286281ce.png";